import { useSelector, TypedUseSelectorHook } from 'react-redux';
import type { RootState } from '../ts/types/store';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
